import ManageLocksContainer from './ManageLocksContainer';


export default ManageLocksContainer;



// WEBPACK FOOTER //
// ./src/components/ManageLocks/index.js